import { useEffect } from 'react';

import { isValidSources } from './isValidSources';
import { useMediaPlayer } from '../../../MediaPlayerProvider';
import { useMediaSourceDetails } from '../../../useMediaSourceDetails';

export const MediaSources: React.FC = () => {
  const mediaDetails = useMediaSourceDetails();
  const { player } = useMediaPlayer();

  useEffect(() => {
    if (player !== null) {
      player.ready(() => {
        const sources = mediaDetails?.sources;
        if (isValidSources(sources)) {
          player.src(sources);
        }
      });
    }
  }, [player, mediaDetails?.sources]);
  return null;
};
